import React from "react";
import { Container } from 'react-bootstrap';
import {Link} from "react-router-dom";
import WOW from "wowjs";

class Hero extends React.Component {

	componentDidMount() {
    	new WOW.WOW().init();
  	}
  	render() {
		return (
			<div className="HereoBanner CluodC-back">
			    <div className="Banner_Content">
					<Container fluid>
						<h2 className="pagehead-title wow fadeInUp">CLOUD <br />COMPUTING</h2>
						<div className="red-border"> </div>
						<p>Harness the power of cloud for your business. Use highly robust and scalable cloud based solutions blended with digiPanda's innovative work approach.</p>
						<Link to="/portfolio" className="red-btn"> Explore Our Work </Link>
					</Container>
				</div>
			</div>
		);
	}
};

export default Hero;
